import { get, post } from '../http-calls';

export const getMADashboardCategoryGetDetailsById = async (id) => {
    let res = await get(`MADashboardCategory/MADashboardCategoryGetDetails?MADashboardCategoryId=${id}`, { useAuthToken: true });
    return res;
};

export const postMADashboardCategoryAddUpdate = async (data) => {
    let res = await post(`MADashboardCategory/MADashboardCategoryAddUpdate`, data, { useAuthToken: true });
    return res;
};

export const getMADashboardCategoryDropdown = async (MADashboardID) => {
    let res = await get(`MADashboardCategory/ScreenDropdown?MADashboardID=${MADashboardID}`, { useAuthToken: true });
    return res;
};

export const postMADashboardCategory_Delete = async (MADashboardCategoryId) => {
    let res = await post(`MADashboardCategory/MADashboardCategory_Delete?MADashboardCategoryId=${MADashboardCategoryId}`, {}, { useAuthToken: true });
    return res;
};

export const postMADashboardMappingCategory_SwapSequence = async (MADashboardMappingCategoryID1, MADashboardMappingCategoryID2) => {
    let res = await post(
        `MADashboardCategory/MADashboardMappingCategory_SwapSequence?MADashboardMappingCategoryID1=${MADashboardMappingCategoryID1}&MADashboardMappingCategoryID2=${MADashboardMappingCategoryID2}`,
        {},
        { useAuthToken: true }
    );
    return res;
};
